var map = {
	"./": 41193,
	"./brand-apple-music": 59809,
	"./brand-apple-music.js": 59809,
	"./brand-spotify": 16611,
	"./brand-spotify.js": 16611,
	"./brand-youtube": 75642,
	"./brand-youtube.js": 75642,
	"./index": 41193,
	"./index.js": 41193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 77680;
module.exports = webpackContext;